import { render, staticRenderFns } from "./editFertigerComponent.vue?vue&type=template&id=9c81edc8&scoped=true"
import script from "./editFertigerComponent.vue?vue&type=script&lang=js"
export * from "./editFertigerComponent.vue?vue&type=script&lang=js"
import style0 from "./editFertigerComponent.vue?vue&type=style&index=0&id=9c81edc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c81edc8",
  null
  
)

export default component.exports